<template>
  <div>
    <div class="d-flex justify-content-end">
      <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        variant="outline-success"
        class="mb-75 no-print"
        @click="printSpecificContent"
      >
        Print / Download
      </b-button>
    </div>

    <div id="payroll-content">
      <div class="d-flex justify-content-center">
        <h3>PAYSLIP FOR THE MONTH OF {{ this.allocationDate }}</h3>
      </div>

      <div class="d-flex justify-content-center mt-1">
        <b-row class="border w-100">
          <b-col cols="6">
            <b-row>
              <b-col class="font-weight-bold p-1 border-bottom border-right"
                >Employee Name</b-col
              >
              <b-col class="p-1 border-bottom border-right">{{
                employee.firstName
              }}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bold p-1 border-bottom border-right"
                >Position</b-col
              >
              <b-col class="p-1 border-bottom border-right">{{
                employee.designationName
              }}</b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col class="font-weight-bold p-1 border-bottom border-right"
                >Department</b-col
              >
              <b-col class="p-1 border-bottom border-right">{{
                employee.departmentName
              }}</b-col>
            </b-row>
            <b-row>
              <b-col class="font-weight-bold p-1 border-right">Total</b-col>
              <b-col class="p-1 border-right">MUR {{ this.getTotal }}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <div class="d-flex mt-3 justify-content-center">
        <h3>INCOME</h3>
      </div>

      <b-table
        bordered
        class="mt-1"
        responsive
        head-variant="light"
        :fields="payrollIncomeFields"
        :items="incomeItems"
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(category)="data">
          {{ data.item.category }}
        </template>
        <template #cell(amount)="data">
          {{ data.item.amount }}
        </template>
        <template #cell(allocationType)="data">
          {{ data.item.allocationType }}
        </template>
      </b-table>

      <div class="d-flex mt-3 justify-content-center">
        <h3>DEDUCTION</h3>
      </div>

      <b-table
        bordered
        class="mt-1"
        responsive
        head-variant="light"
        :fields="payrollDeductionsFields"
        :items="deductionItems"
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(category)="data">
          {{ data.item.category }}
        </template>
        <template #cell(amount)="data">
          {{ data.item.amount }}
        </template>
        <template #cell(allocationType)="data">
          {{ data.item.allocationType }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BRow, BCol, BTable, BButton } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
  },

  data() {
    return {
      id: this.$route.params.id,
      employee : {},
      allocationDate: this.$route.params.allocationDate,
      fields: [
        { key: "name", label: "Employee Name" },
        { key: "id", label: "Employee ID" },
        { key: "location", label: "Location" },
        { key: "position", label: "Position" },
        { key: "dept", label: "Department" },
        { key: "month_year", label: "Month/Year" },
      ],
      payrollIncomeFields: [
        { key: "category", label: "Description" },
        { key: "amount", label: "Earnings (MUR)" },
      ],
      payrollDeductionsFields: [
        { key: "category", label: "Description" },
        { key: "amount", label: "Deduction (MUR)" },
      ],
    };
  },
  computed: {
    ...mapGetters("employeeModule", {
      employeeid: "employeeid",
      loading: "loading",
    }),
    ...mapGetters("allocationModule", {
      allocation: "allocation",
      payroll: "payroll",
      loading: "loading",
    }),
    getTotal() {
      return (
        this.incomeItems.reduce((sum, item) => sum + item.amount, 0) -
        this.deductionItems.reduce((sum, item) => sum + item.amount, 0)
      );
    },

    incomeItems() {
      return this.payroll.filter((item) => item.allocationType === 0);
    },
    deductionItems() {
      return this.payroll.filter((item) => item.allocationType === 1);
    },
    formattedHireDate() {
      const date = new Date(this.employee.hireDate);
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${year}`;
    },
    currentMonthYear() {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const now = new Date();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();
      return `${monthName} ${year}`;
    },
    fullname() {
      return `${this.employee.firstName} ${this.employee.lastName}`;
    },
  },
  methods: {
    ...mapActions("employeeModule", ["getEmployeeByIdAction"]),
    ...mapActions("allocationModule", ["getPayrollListAction"]),
    getDate(date) {
      if (date) {
        const options = { year: "numeric", month: "long" }; // 'long' gives the full month name
        return new Date(date)
          .toLocaleDateString("en-US", options)
          .toUpperCase();
      }
      return "-"; // In case the date is null or invalid
    },

    async printSpecificContent() {
      // Get the content to print
      const printContent = document.getElementById("payroll-content").innerHTML;

      // Save the current page content
      const originalContent = document.body.innerHTML;

      // Replace the body content with the content to print
      document.body.innerHTML = `
    <html>
      <head>
        <title>Print Payroll</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid black; padding: 8px; text-align: left; }
          h3 { text-align: center; }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `;

      // Trigger the print dialog
      window.print();

      // Restore the original content after printing
      document.body.innerHTML = originalContent;

      // Ensure Vue components are re-rendered after restoring the content
      window.location.reload();
    },
  },
  async mounted() {
    this.getPayrollListAction({
      allocationDate: this.allocationDate,
      employeeId: this.id,
    });
    await this.getEmployeeByIdAction(this.id);
    this.employee = this.employeeid;
  },
};
</script>
